import axios from 'axios';
import Swal from 'sweetalert2';

/**
 * Shared iDenfy verification flow: confirmation dialog and API call.
 * Components using this mixin must define onIdenfySuccess() to refetch/update data after a successful request.
 */
export default {
  methods: {
    getIdenfyStatusLabel(status) {
      const labels = {
        0: 'Not verified',
        1: 'Verification required',
        2: 'Verified',
        3: 'Failed',
        4: 'System error'
      };
      return labels[status] ?? 'Unknown';
    },

    async openModal(status, channelId) {
      const statusLabel = this.getIdenfyStatusLabel(status);
      const confirmed = await Swal.fire({
        title: 'iDenfy Verification Status',
        html: `Are you sure that you want to change the status of verification?<br><br><strong>Current status:</strong> ${statusLabel}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });
      if (confirmed.isConfirmed) {
        await this.sendIdenfy(channelId);
      }
    },

    async sendIdenfy(channelId) {
      try {
        await axios.post(`/admin/channel/idenfy/${channelId}`);
        this.$toast.success('Request sent successfully!');
        if (typeof this.onIdenfySuccess === 'function') {
          this.onIdenfySuccess();
        }
      } catch (error) {
        console.error('Error:', error);
        this.$toast.error('Failed to send request.');
      }
    }
  }
};
